
class PointsStorage {
    addPoints(quantity = 1) {
        this.points = this.points + quantity
    }

    resetPoints() {
        this.points = 0
    }

    get points() {
        const point = +localStorage.getItem('activityPoints')
        return Number.isSafeInteger(point) && point > 0 ? point : 0
    }

    set points(value) {
        localStorage.setItem('activityPoints', String(value))
    }
}

